import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-vehicle-list-placeholder',
  templateUrl: './vehicle-list-placeholder.component.html',
  styleUrls: ['./vehicle-list-placeholder.component.css']
})
export class VehicleListPLaceholderComponent implements OnInit {

  @Input() count: number;

  constructor() { }

  ngOnInit(): void {
  }

}
